// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"f63ffa21","564":"96947063","809":"7d67b532","839":"6dfe95f4","929":"27463d4d","992":"ce2c45b9"}[chunkId] + ".chunk.js";
};